
import { removeVersionFromPath } from '../../../utils/index';
import {
    cppShellExecuteEx,
    cppGetCurrentDir,
    // cppRegReadValue,
    cppValidFileExist,
    cppAccHelperWindowClose,
    cppAccHelperWindowShow,
    cppGetWindowPos,
    cppScreenSize,
    cppCheckProcessExist,
    cppAccHelperWindowSetPosition,
    cppGetAudioDeviceInfoList,
    cppSetDefaultAudioDevice,
    cppInstallRootDriver,
    cppRenameAudioDevice,
} from '../../../api/cpp';

function getAccHelperPos() {
    const cunrrentWindowPos = cppGetWindowPos();
    const screenSize = cppScreenSize();
    if (!cunrrentWindowPos || !screenSize) {
        return false;
    }
    const {x, y} = cunrrentWindowPos
    const {width, height} = screenSize
    if (typeof x !== 'number' || typeof y !== 'number' || typeof width !== 'number' || typeof height !== 'number') {
        return false;
    }
    const offsetX = 253;
    const offsetY = 380;
    let posX, posY;
    if (x < width - 530) {
        posX = x + offsetX;
    } else {
        posX = x - offsetX;
    }
    if (y > height - 648) {
        posY = height - offsetY;
    } else {
        posY = y + 50;
    }
    return {
        x: posX,
        y: posY
    }
}

// 获取伴奏助手路径
export const getAccHelperPath = () => {
    const currentDir = cppGetCurrentDir();
    const cleanedDir = removeVersionFromPath(currentDir);
    return `${cleanedDir}\\acchelper`;
}
// 打开伴奏助手
export const startAccHelper = () => {
    checkAndInstallDriver().then((isSuccess) => {
        console.log('checkAndInstallDriver result', isSuccess);
        runAccHelper();
    }).catch(error => {
        console.log('checkAndInstallDriver error', error);
        runAccHelper();
    });
}
export const runAccHelper = () => {
    const accHelperPath = getAccHelperPath();
    const posParam = getAccHelperPos();
    const lpParameters = posParam ? `--noquit --pos=${posParam.x},${posParam.y}` : '--noquit'
    cppShellExecuteEx({
        lpFile: `${accHelperPath}\\yyboxmixerclient.exe`,
        lpDirectory: accHelperPath,
        // lpVerb: 'runas',
        lpParameters: lpParameters,
        nShow: 0
    })
}
// 关闭伴奏助手
export const closeAccHelper = () => {
    cppAccHelperWindowClose()
}
// 展示伴奏助手
export const showAccHelper = () => {
    if (cppCheckProcessExist('yyboxmixerclient.exe')) {
        const posParam = getAccHelperPos();
        if (posParam) {
            cppAccHelperWindowSetPosition(posParam);
        }
        cppAccHelperWindowShow()
    } else {
        runAccHelper()
    }
}

// 获取设备列表
const acchelperVirtualDeivce = {
    name: '播放器通道-伴奏助手专用',
    interfaceName: 'remotly virtual audio',
    type: 'render',
    infPath: 'driver\\RemotlyVirtualAudio.inf',
    hardwareId: 'ROOT\\RemotlyVirtualAudio'
};

// cppRenameAudioDevice('render','remotly virtual audio', '播放器通道-伴奏助手专用')
// JSON.parse(cppGetAudioDeviceInfoList())
export const checkAndInstallDriver = () => {
    return new Promise((resolve, reject) => {
        const deviceList = cppGetAudioDeviceInfoList();
        if (!deviceList || !Array.isArray(deviceList)) {
            reject('获取设备列表失败');
            return;
        }
        const renderList = deviceList.filter(device => device.type === acchelperVirtualDeivce.type);
        const driverDevice = renderList.find(device => toLowerCase(device.interfaceName) === toLowerCase(acchelperVirtualDeivce.interfaceName));
        if (driverDevice) {
            // 如果设备已经存在，直接返回成功
            console.log('驱动设备已存在');
            resolve(true);
            // 重命名软声卡设备名称
            cppRenameAudioDevice(acchelperVirtualDeivce.type, acchelperVirtualDeivce.interfaceName, acchelperVirtualDeivce.name);
            return;
        }
        const curDefaultDeviceId = renderList.find(device => device.isDefault).id;
        console.log('renderList', renderList);
        console.log('driverDevice', driverDevice);
        const accHelperPath = getAccHelperPath();
        console.log('安装驱动:acchelperVirtualDeivce.hardwareId', acchelperVirtualDeivce.hardwareId);
        console.log('安装驱动:acchelperVirtualDeivce.infPath', `${accHelperPath}\\${acchelperVirtualDeivce.infPath}`);
        const driverInstallRes = cppInstallRootDriver(acchelperVirtualDeivce.hardwareId, `${accHelperPath}\\${acchelperVirtualDeivce.infPath}`);
        console.log('驱动安装结果');
        console.log(driverInstallRes);
        if (driverInstallRes.success) {
            console.log('安装驱动成功');
            let retryCount = 0;
            const maxRetries = 4;
            const intervalId = setInterval(() => {
                retryCount++;
                if (checkDriverDeviceExists()) {
                    clearInterval(intervalId);
                    resolve(true);
                    // 安装成功后将原本的默认设备再设置为默认设备
                    cppSetDefaultAudioDevice(curDefaultDeviceId);
                    // 重命名软声卡设备名称
                    cppRenameAudioDevice(acchelperVirtualDeivce.type, acchelperVirtualDeivce.interfaceName, acchelperVirtualDeivce.name);
                } else if (retryCount >= maxRetries) {
                    clearInterval(intervalId);
                    console.log('没有检测到安装驱动设备');
                    resolve(false);
                }
            }, 5000);
        } else {
            console.log('安装驱动失败');
            resolve(false);
        }
    })
}

// 检查驱动设备是否存在
export const checkDriverDeviceExists = () => {
    console.log('检测驱动设备是否存在');
    const deviceList = cppGetAudioDeviceInfoList();
    const renderList = deviceList.filter(device => device.type === acchelperVirtualDeivce.type);
    const driverDevice = renderList.find(device => device.interfaceName.toLowerCase() === acchelperVirtualDeivce.interfaceName.toLowerCase());
    console.log('检测结果', driverDevice);
    return !!driverDevice;
}

// 伴奏助手ASIO调用方式修改 不需要注册ASIO了
// 检查并注册 ASIO 驱动（结果不影响伴奏助手启动） 
// ASIO 驱动 DLL 文件名（位于 acchelper 目录下）
// const ASIO_DRIVER_DLL = 'YYBoxASIO.dll';
// export const checkAndRegisterASIO = () => {
//     try {
//         const accHelperPath = getAccHelperPath();
//         const dllPath = `${accHelperPath}\\${ASIO_DRIVER_DLL}`;

//         // 验证1：ASIO 注册表项的 CLSID 值是否存在
//         const clsid = cppRegReadValue("HKLM", "SOFTWARE\\ASIO\\YYBox ASIO Driver", "CLSID");
//         if (clsid) {
//             // 验证2：CLSID 对应的 InprocServer32 默认值是否包含 DLL 文件名
//             const inprocServer32 = cppRegReadValue(
//                 "HKLM",
//                 "SOFTWARE\\Classes\\CLSID\\{8BC36D10-8C5D-4A4F-9E3A-7F8B5C6D4E2F}\\InprocServer32",
//                 ""
//             );
//             if (inprocServer32 && inprocServer32.toLowerCase().includes(ASIO_DRIVER_DLL.toLowerCase())) {
//                 console.log('ASIO driver already registered, InprocServer32:', inprocServer32);
//                 return;
//             }
//             console.log('ASIO InprocServer32 mismatch, expected contains:', ASIO_DRIVER_DLL, 'got:', inprocServer32);
//         }

//         console.log('ASIO driver not registered, registering...');
//         cppShellExecuteEx({
//             lpFile: 'regsvr32.exe',
//             lpVerb: 'runas',
//             lpParameters: `/s "${dllPath}"`,
//             nShow: 0
//         });
//         console.log('ASIO driver registration initiated:', dllPath);
//     } catch (error) {
//         console.log('checkAndRegisterASIO error:', error);
//     }
// }

// 伴奏助手关键文件列表
const ACC_HELPER_CRITICAL_FILES = [
    'C:\\ProgramData\\acchelper\\Remix\\desktop.ini',
    'C:\\ProgramData\\acchelper\\AIModels\\VocalsSeparation.hance',
    'C:\\ProgramData\\acchelper\\Remix\\Localization\\Remix_de.loc',
];
// 伴奏助手安装目录(getAccHelperPath() 返回的 ...\acchelper)下的关键文件
const ACC_HELPER_INSTALL_FILES = [
    'YYBoxASIO.dll',
];
// 检查伴奏助手关键文件是否完整
// 返回缺失文件列表，空数组表示全部存在
export const checkAccHelperFiles = () => {
    const missingFiles = [];
    // 1. ProgramData 固定目录下的关键文件
    ACC_HELPER_CRITICAL_FILES.forEach(file => {
        if (!cppValidFileExist(file)) {
            missingFiles.push(file);
            console.log('AccHelper file missing:', file);
        }
    });
    // 2. 伴奏助手安装目录下的关键文件
    const installDir = getAccHelperPath();
    ACC_HELPER_INSTALL_FILES.forEach(relPath => {
        const fullPath = `${installDir}\\${relPath}`;
        if (!cppValidFileExist(fullPath)) {
            missingFiles.push(fullPath);
            console.log('AccHelper file missing:', fullPath);
        }
    });
    return missingFiles;
}

function toLowerCase(str) {
    if (typeof str !== 'string') {
        return str;
    }
    return str.toLowerCase();
}
